<template>
    <div class="finance" v-can="'finance_access.access'">
        <div class="flex justify-center">
            <c-loader class="mr-2" v-if="!isMounted" color="rgba(var(--vs-primary),1)"/>
        </div>
        <div v-if="isMounted">
            <filter-fields @refresh="refreshFilter">
                <vs-row>
                    <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                        <div class="p-2 flex items-center">
                            <vs-checkbox
                                :disabled="!disabled.is_send_date && !disabled.is_first_action_date"
                                class="mt-6"
                                v-model="disabled.is_created_at"
                            ></vs-checkbox>
                            <div class="w-full">
                                <label class="text-sm opacity-75">{{ $t('global.Registration_date') }}</label>
                                <date-picker
                                    :date="dateSystem.created_at"
                                    direction="created_at"
                                    @select="selectDate"
                                    :disabled="!disabled.is_created_at"
                                />
                            </div>
                        </div>
                    </vs-col>

                    <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                        <div class="p-2 flex items-center">
                            <vs-checkbox
                                :disabled="!disabled.is_created_at && !disabled.is_first_action_date"
                                class="mt-6"
                                v-model="disabled.is_send_date"
                            ></vs-checkbox>
                            <div class="w-full">
                                <label class="text-sm opacity-75">{{ $t('global.Send_date') }}</label>
                                <date-picker
                                    :date="dateSystem.send_date"
                                    direction="send_date"
                                    @select="selectDate"
                                    :disabled="!disabled.is_send_date"
                                />
                            </div>
                        </div>
                    </vs-col>

                    <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                        <div class="p-2 flex items-center">
                            <vs-checkbox
                                :disabled="!disabled.is_created_at && !disabled.is_send_date"
                                class="mt-6"
                                v-model="disabled.is_first_action_date"
                            ></vs-checkbox>
                            <div class="w-full">
                                <label class="text-sm opacity-75">{{ $t('global.Deposit_date') }}</label>
                                <date-picker
                                    :date="dateSystem.first_action_date"
                                    direction="first_action_date"
                                    @select="selectDate"
                                    :disabled="!disabled.is_first_action_date"
                                />
                            </div>
                        </div>
                    </vs-col>

                    <vs-col
                        vs-w="12"
                        vs-sm="6"
                        vs-lg="3"
                        vs-xs="12"
                        v-for="(value, key) in filters.options"
                    >
                        <div class="p-2">
                            <label class="text-sm opacity-75">{{ $t(`table_filters.${key}`) }}</label>
                            <v-select
                                autocomplete
                                :placeholder="$t(`table_filters.${key}`)"
                                class="w-full"
                                multiple
                                :options="value"
                                :reduce="item => item.id"
                                label="name"
                                :closeOnSelect="false"
                                v-model="filters.selectSystem[key]"
                                :selectable="item => item.disabled"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                        <div class="p-2">
                            <label class="text-sm opacity-75">{{ $t('global.Email') }}</label>
                            <vs-input
                                class="inputx w-full no_focus"
                                :placeholder="$t('global.Email')"
                                v-model="filters.selectSystem.email"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="12">
                        <div class="flex justify-between items-center mt-4">
                            <div class="flex">
                                <vs-button
                                    @click="refreshTable"
                                    v-tooltip="$t('tooltip.Refresh_table')"
                                    class="mr-2"
                                    radius
                                    type="flat"
                                    v-bind="$iconData('icon-rotate-cw', 'fi-rr-rotate-right')"
                                    :disabled="!leads.length"
                                ></vs-button>

                                <vs-dropdown :disabled="!leads.length" class="cursor-pointer mr-2" vs-custom-content vs-trigger-click>
                                    <a class="flex items-center cursor-pointer" href.prevent>
                                        <feather-icon class="mr-1" icon="SlidersIcon" svgClasses="h-4 w-4 ml-1"/>
                                        <span>{{ $t('global.view') }}</span>
                                    </a>

                                    <vs-dropdown-menu>
                                        <ul>
                                            <li class="flex items-center" v-for="(h, i) of heads"
                                                :key="i"
                                                v-if="isPermission(h.can || '')"
                                            >
                                                <vs-button
                                                    radius
                                                    color="primary"
                                                    type="flat"
                                                    icon-pack="feather"
                                                    @click="h.display = !h.display"
                                                    :icon="h.display ? 'icon-eye' : 'icon-eye-off'"
                                                ></vs-button>
                                                <span class="ml-2 mr-4 whitespace-no-wrap">{{ $t(h.name) }}</span>
                                            </li>
                                        </ul>
                                    </vs-dropdown-menu>
                                </vs-dropdown>
                                <vs-button
                                    v-can="'finance_access.download_csv'"
                                    class="ml-2"
                                    @click="downloadCSV"
                                    v-tooltip="$t('tooltip.Download_CSV')"
                                    radius
                                    type="flat"
                                    v-bind="$iconData('icon-download', 'fi-rr-download')"
                                    :disabled="!leads.length"
                                ></vs-button>
                                <vs-button
                                    v-can="'finance_access.change_internal_teams'"
                                    class="ml-2"
                                    @click="selectTeams"
                                    v-tooltip="$t('global.Teams')"
                                    radius
                                    type="flat"
                                    v-bind="$iconData('icon-users', 'fi-rr-users')"
                                ></vs-button>
                            </div>

                            <div class="flex items-center">
                                <c-loader class="mr-2" v-if="loading" color="rgba(var(--vs-primary),1)"/>
                                <vs-button
                                    class="mr-2"
                                    color="primary"
                                    @click="submitFilter"
                                    type="filled"
                                    :disabled="loading"
                                >
                                    {{ $t('buttons.Filter') }}
                                </vs-button>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
            </filter-fields>

            <no-data v-if="!leads.length"></no-data>

            <ds-table
                v-else
                :data="leads"
                :heads="heads"
                spacer
                ssr
                :view-items="[500, 1000, 1500]"
                :total="pagination.count_all"
                :max-items="limitNum"
                :page="pageNum"
                @page="page"
                @limit="limit"
                @sort="sort"
                :disabled="loading"
            >
                <template v-slot:regdate="{regdate}">
                    <div>
                        <div style="font-size: 11px; color: grey;">{{ regdate.day_created }}</div>
                        <div v-if="!regdate.created_at">-</div>
                        <div v-else>{{ regdate.created_at|date }}</div>
                    </div>
                </template>

                <template v-slot:senddate="{senddate}">
                    <div>
                        <div style="font-size: 11px; color: grey;">{{ senddate.day_sended }}</div>
                        <div v-if="!senddate.send_date">-</div>
                        <div v-else>{{ senddate.send_date|date }}</div>
                    </div>
                </template>

                <template v-slot:depositdate="{depositdate}">
                    <div>
                        <div style="font-size: 11px; color: grey;">{{ depositdate.month_dep }}</div>
                        <div v-if="!depositdate.first_action_date">-</div>
                        <div v-else>{{ depositdate.first_action_date|date }}</div>
                    </div>
                </template>

                <template v-slot:advertiser="{advertiser}">
                    <div>
                        <div style="font-size: 11px; color: grey;">
                            {{ advertiser.advertiser_is_internal ? $t('global.Internal') : $t('global.External') }}
                        </div>
                        <div>{{ advertiser.advertiser || advertiser.advertiser_id || '-' }}</div>
                    </div>
                </template>
            </ds-table>
        </div>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"
import EventBus from "@/store/eventBus"
import vSelect from "vue-select"
import {download} from "@/utils/utils"
import {checkPermission} from "@/utils/mixins";

export default {
    mixins: [checkPermission],

    data() {
        return {
            isMounted: false,
            pagination: {},
            limitNum: 500,
            pageNum: 1,
            order_by: {},
            loading: false,
            disabled: {
                is_send_date: true,
                is_created_at: true,
                is_first_action_date: true
            },
            filters: {
                options: {},
                selectSystem: {},
                select: {}
            },
            dateSystem: {
                created_at: {startDate: new Date(), endDate: new Date()},
                send_date: {startDate: new Date(), endDate: new Date()},
                first_action_date: {startDate: new Date(), endDate: new Date()},
            },
            dataFilter: {},
            leads: [],
            heads: [
                {name: 'global.Registration_date', key: 'created_at', value: 'regdate', sortKey: 'created_at', display: true},
                {name: 'global.Send_date', key: 'send_date', value: 'senddate', sortKey: 'send_date', display: true},
                {name: 'global.Deposit_date', key: 'first_action_date', value: 'depositdate', sortKey: 'first_action_date', display: true},
                {name: 'global.Advertiser_category', key: 'advertiser_category', value: 'advertiser_category', sortKey: 'advertiser_category', display: true},
                {name: 'global.Advertiser', key: 'advertiser', value: 'advertiser', sortKey: 'advertisers', display: true},
                {name: 'global.Affiliates', key: 'affiliate_name', value: 'affiliate_name', sortKey: 'affiliates', display: true},
                {name: 'global.Offer', key: 'offer_name', value: 'offer_name', sortKey: 'offer_name', display: true},
                {name: 'global.Team_ID', key: 'team_id', value: 'team_id', sortKey: 'team_id', display: true},
                {name: 'global.Team', key: 'team_name', value: 'team_name', sortKey: 'team_name', display: true, can: 'settings_team.show_team_name'},
                {name: 'global.Status', key: 'group_status', value: 'group_status', sortKey: 'statuses', display: true},
                {name: 'global.Email', key: 'email', value: 'email', sortKey: 'email', display: true},
                {name: 'global.Model', key: 'traffic_models_name', value: 'traffic_models_name', sortKey: 'traffic_models', display: true},
                {name: 'global.Geo', key: 'geo', value: 'geo', sortKey: 'geo', display: true},
                {name: 'global.Country', key: 'country', value: 'country', sortKey: 'countries', display: true},
                {name: 'global.Language', key: 'language', value: 'language', sortKey: 'language', display: true},
                {name: 'label.External_price', key: 'external_price', value: 'external_price', sortKey: 'external_price', display: true},
                {name: 'label.Internal_price', key: 'internal_price', value: 'internal_price', sortKey: 'internal_price', display: true},
            ],
        }
    },

    components: {
        vSelect
    },

    methods: {
        dateParse(date) {
            return new Date(date).toLocaleString('ru').split(',')[0].split('.').reverse().join('-')
        },

        async refreshFilter() {
            this.initialStartDate()

            this.filters.selectSystem = {}
            this.filters.select = {}

            Object.keys(this.disabled).map(key => this.disabled[key] = true)

            await this.get(true)
        },

        async submitFilter() {
            this.dataFilter.send_date_from = this.dateParse(this.dateSystem.send_date.startDate)
            this.dataFilter.send_date_to = this.dateParse(this.dateSystem.send_date.endDate)

            this.dataFilter.created_date_from = this.dateParse(this.dateSystem.created_at.startDate)
            this.dataFilter.created_date_to = this.dateParse(this.dateSystem.created_at.endDate)

            this.dataFilter.first_action_date_from = this.dateParse(this.dateSystem.first_action_date.startDate)
            this.dataFilter.first_action_date_to = this.dateParse(this.dateSystem.first_action_date.endDate)

            if (!this.disabled.is_created_at) {
                delete this.dataFilter.created_date_from
                delete this.dataFilter.created_date_to
            }

            if (!this.disabled.is_send_date) {
                delete this.dataFilter.send_date_from
                delete this.dataFilter.send_date_to
            }

            if (!this.disabled.is_first_action_date) {
                delete this.dataFilter.first_action_date_from
                delete this.dataFilter.first_action_date_to
            }

            this.filters.select = this.filters.selectSystem
            this.pageNum = 1
            await this.get(true)
        },

        selectTeams() {
            EventBus.$emit('emitPopupEvent', {type: 'selectTeams', name: this.$t('global.Teams')})
        },

        async downloadCSV() {
            try {
                const params = {
                    filter_required: true,
                    ...this.dataFilter,
                    ...this.removeEmptyFields(this.filters.select)
                }

                // if (params.advertisers) {
                //     params.advertisers = params.advertisers.map(item => {
                //         item = this.filters.options.advertisers.find(adv => adv.id === item)._name
                //         return item
                //     })
                // }

                Object.keys(params).map(key => {
                    if (key === 'advertisers_categories') {
                        params[key] = params[key].map(item => ({advertiser_category_id: item}))
                    }
                })

                const response = await send(this.$url.financeStatistic.exportcsv, 'POST', {data: params})
                    .then(response => response.data)

                const name = this.dateParse(new Date())
                const time = new Date().getTime()
                download(response, `${name}_${time}.csv`, 'text/csv')
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async refreshTable() {
            await this.get()
        },

        selectDate(data) {
            this.dateSystem[data.direction] = data
        },

        async page(page) {
            if (page !== this.pageNum) {
                this.pageNum = page
                await this.get()
            }
        },

        async limit(limit) {
            if (limit !== this.limitNum) {
                this.limitNum = limit

                if (this.pageNum !== 1) {
                    this.pageNum = 1
                } else {
                    await this.get()
                }
            }
        },

        async sort(sort) {
            this.order_by = sort.type ? {[sort.name]: sort.type} : {}
            await this.get()
        },

        copy(data) {
            return JSON.parse(JSON.stringify(data))
        },

        removeEmptyFields(data) {
            return Object.entries(data).reduce((res, [key, value]) => {
                if (value !== undefined && value !== null && value.length) {
                    res[key] = value
                }
                return res
            }, {})
        },

        isObject(value) {
            return typeof value === "object" && value !== undefined && value !== null && !Array.isArray(value)
        },

        createFilter(data) {
            try {
                const filters = Object.entries(data).reduce((res, [key, value]) => {
                    res[key] = value.map(item => {
                        if (this.isObject(item)) {
                            if (item.id) {
                                return {
                                    ...item,
                                    disabled: true
                                }
                            } else {
                                let id

                                Object.keys(item).map(k => {
                                    if (/_id/.test(k)) id = item[k]
                                })

                                return {
                                    id: id || item.name,
                                    name: item.name,
                                    disabled: true
                                }
                            }
                        } else {
                            return {
                                id: item,
                                name: item,
                                disabled: true
                            }
                        }
                    })

                    res[key] = res[key].filter(item => item.name)

                    return res
                }, {})

                const obj = this.copy(filters)

                if (Object.keys(this.filters.selectSystem).length) {
                    Object.entries(this.filters.options).map(([key, value]) => {
                        value.map(item => {
                            const some = obj[key].some(filter => filter.id === item.id)
                            if (!some) obj[key].push(item)
                        })
                    })

                    Object.entries(obj).map(([key, value]) => {
                        obj[key] = value.map(item => {
                            const ids = filters[key].map(filter => filter.id)
                            item.disabled = ids.includes(item.id)

                            return item
                        })
                    })
                }

                return obj
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        monthDate() {
            const d = new Date()
            return d.setMonth(d.getMonth() - 1)
        },

        initialStartDate() {
            Object.keys(this.dateSystem).map(key => {
                this.dateSystem[key].startDate = new Date(this.monthDate())
                this.dateSystem[key].endDate = new Date()
            })

            this.dataFilter.send_date_from = this.dateParse(new Date(this.monthDate()))
            this.dataFilter.send_date_to = this.dateParse(new Date())
            this.dataFilter.created_date_from = this.dateParse(new Date(this.monthDate()))
            this.dataFilter.created_date_to = this.dateParse(new Date())
            this.dataFilter.first_action_date_from = this.dateParse(this.dateSystem.first_action_date.startDate)
            this.dataFilter.first_action_date_to = this.dateParse(this.dateSystem.first_action_date.endDate)
        },

        async get(filter_required) {
            try {
                this.loading = true

                this.filters.selectSystem = this.removeEmptyFields(this.filters.selectSystem)

                const data = {
                    ...this.dataFilter,
                    filter_required: !!filter_required,
                    limit: this.limitNum,
                    page: this.pageNum,
                    order_by: this.order_by,
                    ...this.removeEmptyFields(this.filters.select)
                }

                if (data.advertisers_categories && Array.isArray(data.advertisers_categories)) {
                    data.advertisers_categories = data.advertisers_categories.map(id => ({advertiser_category_id: id}))
                }

                // if (data.advertisers) {
                //     data.advertisers = data.advertisers.map(item => {
                //         const name = this.filters.options.advertisers.find(adv => adv.id === item)._name
                //         item = (name || item).toString()
                //         return item
                //     })
                // }

                if (!Object.keys(data.order_by).length) {
                    delete data.order_by
                }

                const response = await send(this.$url.financeStatistic.get, 'POST', {data}, false)
                    .then(response => response.data.result)

                this.leads = response.leads
                this.pagination = response.pagination

                if (filter_required) {
                    delete response.filters.integrations

                    response.filters.teams = Object.entries(response.filters.teams).map(([id, name]) => ({
                        id: parseInt(id, 10),
                        name: this.isPermission('settings_team.show_team_name') ? `${id} - ${name}` : `${id}`
                    }));

                    response.filters.advertisers = Object.entries(response.filters.advertisers).map(([id, name]) => ({
                        id: parseInt(id, 10),
                        name: this.isPermission('settings_advertiser.show_advertiser_name') ? `${id} - ${name}` : `${id}`,
                        _name: this.isPermission('settings_advertiser.show_advertiser_name') ? name : id
                    }));

                    this.filters.options = this.createFilter(response.filters)

                    const sortById = ['teams', 'advertisers']
                    Object.keys(this.filters.options).forEach(key => {
                        if (sortById.includes(key)) {
                            this.filters.options[key].sort((a, b) => ~~a.id - ~~b.id);
                        } else {
                            this.filters.options[key].sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)
                        }

                        this.filters.options[key].sort((a, b) => b.disabled - a.disabled)
                    })
                }

                if (!this.isPermission('finance_access.show_external_price')) {
                    delete this.filters.options.external_price
                    this.heads = this.heads.filter(item => item.key !== 'external_price')
                }

                if (!this.isPermission('finance_access.show_internal_price')) {
                    delete this.filters.options.internal_price
                    this.heads = this.heads.filter(item => item.key !== 'internal_price')
                }

                this.isMounted = true
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.loading = false
            }
        }
    },

    async mounted() {
        this.initialStartDate()
        await this.get(true)
    }
}
</script>

<style lang="scss">
.finance {
    .vs__dropdown-option--disabled {
        background-color: #f6f6f6;
        color: rgba(0, 0, 0, 0.28) !important;
    }

    .vs-con-dropdown[disabled="disabled"] {
        opacity: .5;
        cursor: default;
        pointer-events: none;
    }
}
</style>
